class ClickAirTestimonials extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('[data-ts-viewport]');
    this.track = this.querySelector('[data-ts-track]');
    this.slides = Array.from(this.querySelectorAll('[data-ts-slide]'));
    this.prevBtn = this.querySelector('[data-ts-prev]');
    this.nextBtn = this.querySelector('[data-ts-next]');
    this.dotsWrap = this.querySelector('[data-ts-dots]');

    if (!this.viewport || !this.track || this.slides.length === 0) return;

    this.index = 0;
    this.mobileQuery = window.matchMedia('(max-width: 749px)');

    this.onPrev = () => this.step(-1);
    this.onNext = () => this.step(1);
    this.onResize = () => this.update();
    this.onScroll = () => this.syncDotsFromScroll();

    this.prevBtn?.addEventListener('click', this.onPrev);
    this.nextBtn?.addEventListener('click', this.onNext);
    window.addEventListener('resize', this.onResize);
    this.viewport.addEventListener('scroll', this.onScroll, { passive: true });

    this.buildDots();
    this.update();
  }

  disconnectedCallback() {
    this.prevBtn?.removeEventListener('click', this.onPrev);
    this.nextBtn?.removeEventListener('click', this.onNext);
    window.removeEventListener('resize', this.onResize);
    this.viewport?.removeEventListener('scroll', this.onScroll);
  }

  get isMobile() {
    return this.mobileQuery.matches;
  }

  get visibleCount() {
    return this.isMobile ? 1 : 3;
  }

  get maxIndex() {
    return Math.max(0, this.slides.length - this.visibleCount);
  }

  buildDots() {
    if (!this.dotsWrap) return;

    this.dotsWrap.innerHTML = '';
    this.slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'ca-ts__dot';
      dot.setAttribute('aria-label', `Go to testimonial ${i + 1}`);
      dot.addEventListener('click', () => this.goTo(i));
      this.dotsWrap.appendChild(dot);
    });

    this.dots = Array.from(this.dotsWrap.querySelectorAll('.ca-ts__dot'));
  }

  step(delta) {
    this.goTo(this.index + delta);
  }

  goTo(targetIndex) {
    if (this.isMobile) {
      const slide = this.slides[targetIndex];
      if (!slide) return;
      this.viewport.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      this.index = targetIndex;
      this.updateDots();
      return;
    }

    this.index = Math.min(Math.max(targetIndex, 0), this.maxIndex);
    const slide = this.slides[this.index];
    if (!slide) return;

    this.track.style.transform = `translateX(-${slide.offsetLeft}px)`;
    this.updateDots();
    this.updateButtons();
  }

  syncDotsFromScroll() {
    if (!this.isMobile) return;

    const scrollLeft = this.viewport.scrollLeft;
    let closest = 0;
    let distance = Infinity;

    this.slides.forEach((slide, i) => {
      const d = Math.abs(slide.offsetLeft - scrollLeft);
      if (d < distance) {
        distance = d;
        closest = i;
      }
    });

    this.index = closest;
    this.updateDots();
  }

  updateButtons() {
    if (!this.prevBtn || !this.nextBtn || this.isMobile) return;

    this.prevBtn.disabled = this.index <= 0;
    this.nextBtn.disabled = this.index >= this.maxIndex;
  }

  updateDots() {
    if (!this.dots) return;

    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.index);
      dot.setAttribute('aria-current', i === this.index ? 'true' : 'false');
    });
  }

  update() {
    if (this.isMobile) {
      this.track.style.transform = 'none';
      this.goTo(Math.min(this.index, this.slides.length - 1));
      this.updateButtons();
      return;
    }

    this.index = Math.min(this.index, this.maxIndex);
    const slide = this.slides[this.index];
    if (slide) {
      this.track.style.transform = `translateX(-${slide.offsetLeft}px)`;
    }

    this.updateDots();
    this.updateButtons();
  }
}

if (!customElements.get('clickair-testimonials')) {
  customElements.define('clickair-testimonials', ClickAirTestimonials);
}
